module.exports = __webpack_public_path__ + "img/0910_black.fe3630a7.jpg";